var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$unleash.isFeatureEnabled('enable-portal-logs-with-viewer'))?_c('LogsWithViewer',{staticClass:"mt-5",attrs:{"servers":_vm.servers}}):_c('div',{staticClass:"mt-5"},[_c('Logs',{attrs:{"preselected-services":_vm.selectedServices}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }